import type { ReactNode } from 'react';
import {
  ONBOARDING_INSIGHT_PANEL_ANALYZING_CLASS,
  ONBOARDING_INSIGHT_PANEL_CLASS,
} from '../constants';

interface OnboardingInsightPanelShellProps {
  children: ReactNode;
  /** When true, use a neutral surface without the green result gradient. */
  isAnalyzing?: boolean;
}

export default function OnboardingInsightPanelShell({
  children,
  isAnalyzing = false,
}: OnboardingInsightPanelShellProps) {
  return (
    <div className={isAnalyzing ? ONBOARDING_INSIGHT_PANEL_ANALYZING_CLASS : ONBOARDING_INSIGHT_PANEL_CLASS}>
      {!isAnalyzing ? (
        <>
          <div
            className="pointer-events-none absolute -right-8 -top-8 h-24 w-24 rounded-full bg-emerald-300/25 blur-2xl"
            aria-hidden="true"
          />
          <div
            className="pointer-events-none absolute -bottom-10 -left-6 h-20 w-20 rounded-full bg-teal-400/20 blur-2xl"
            aria-hidden="true"
          />
          <div
            className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-emerald-300/50 to-transparent"
            aria-hidden="true"
          />
        </>
      ) : null}
      <div className="relative">{children}</div>
    </div>
  );
}
